import React from "react";
import ReactDOM from "react-dom";
import BaseDialog from "./BaseDialog";
import Input from "../../form_components/Input";
import BlankElementEmbed from "./BlankElementEmbed";
import Utility from "../../utilities/Utility";

export default class PropertyDialog extends BaseDialog {
    /**
     * Dialog for app properties
     * @module PropertyDialog
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            config: props.property ? props.property.config : null,
            default: props.property ? props.property.default : null,
            variable: props.property ? props.property.variable : null
        };
        this.error = {};
        this.addHandle = this.handleAdd.bind(this);
        this.deleteHandle = this.handleDelete.bind(this);
    }

    /**
     * Add to application
     */
    handleAdd(){
        if (Object.keys(this.error).length) {
            return;
        }
        const varComponents = this.state.variable.split(".");
        const varName = varComponents[varComponents.length - 1];
        const property = {
            type: "variableBinding",
            config: this.state.config,
            default: this.state.default,
            variable: "app." + varName
        };
        
        if (window.apm.getVariable(varName)) {
            const propId = (this.props.property) ? this.props.property.id : null;
            this.props.context.add(property, propId);
            w2popup.close();
        } else {
            const addFunc = (treeL, serialized) => {
                window.apm.addNode(serialized);
                treeL.jstree().create_node("variables", Utility.getTreeNode(serialized), "last");
                this.props.context.add(property);
                w2popup.close();
            };
            w2popup.message({
                width: 500,
                height: 600,
                html: '<div class="blank_container"></div>',
                onOpen: () => {
                    this.intervalHandler = setInterval(() => {
                        if ($(".blank_container")) {
                            clearInterval(this.intervalHandler);
                            $(".w2ui-message").css("transform", "");

                            ReactDOM.render(
                                <BlankElementEmbed key={Utility.uuid4()} addFunc={addFunc} type="variable"
                                    nodeName={varName} />, $(".blank_container").get(0));
                        }
                    }, 10);
                }
            });

        }
    }

    setError(key, message) {
        this.error[key] = message;
    }

    removeError(key) {
        delete this.error[key];
    }

    /**
     * Delete from application
     */
    handleDelete() {
        this.props.context.remove(this.state.config);
        w2popup.close();
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        this.setState({
            [key]: value
        });
    }

    /**
     * Get config proxy
     * @param {string} key
     * @returns {string}
     */
    getConfig(key) {
        return this.state[key];
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
        document.addEventListener("ev-dialog-delete", this.deleteHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
        document.removeEventListener("ev-dialog-delete", this.deleteHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            <Input label="Config Name" valRules={{"noEmpty": true, "objectName": true, "propertyConfigNoDuplicate": true}}
                                   value={this.state.config}
                                   context={this} valKey={"config"}
                                   suppressUpdate={true}/>
                            <Input label="Config Default Value"
                                   value={this.state.default} context={this} valKey={"default"}
                                   suppressUpdate={true}/>
                            <Input label="Variable Binding" valRules={{"noEmpty": true, "propertyVariable": true, "propertyVariableNoDuplicate":true}}
                                   value={this.state.variable} hint={"E.g. app.name"}
                                   context={this} valKey={"variable"} suggestion={"variable"}
                                   suppressUpdate={true}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}